<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <div class="d-flex justify-content-between w-100 align-items-center">
                    <h5 class="mb-0">Avaliação de Despesas Gerais</h5>
                    <div>
                        <b-button
                            v-if="$temAcessoView('DESP-GERAIS-REL-02')"
                            variant="primary"
                            @click.stop="abrirModalRelatorioDetalhado()"
                        >
                            <i class="fa fa-list"></i>
                            Detalhamento das avaliações
                        </b-button>
                        <b-button
                            v-if="$temAcessoView('DESP-GERAIS-REL-01')"
                            class="ml-2"
                            variant="primary"
                            @click.stop="abrirModalRelatorioResumido()"
                        >
                            <i class="fa fa-list"></i>
                            Resumo das avaliações
                        </b-button>
                    </div>
                </div>
            </b-card-header>
            <b-card-body>
                <app-tabela
                :itens="avaliacoes"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
                :mostrarFiltro="false"
                >
                <template slot="respostas" slot-scope="data">
                        <app-tabela
                            :itens="data.respostas"
                            :campos="camposRespostas"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                            :mostrarFiltro="false"
                        >
                            <template slot="percentual" slot-scope="data">
                                <span>{{ data.percentual | currency2 }}</span>
                            </template>
                        </app-tabela>
                    </template>
                    <template slot="grafico" slot-scope="data">
                        <div class="chart-wrapper">
                            <grafico
                                v-if="data.perguntaId"
                                :id="`${data.perguntaId}`"
                                :titulos="obterTitulos(data.respostas)"
                                :valores="obterValores(data.respostas)"
                            ></grafico>
                        </div>
                    </template>
                </app-tabela>
                
                <ocorrencias
                    :problemas="problemas"
                ></ocorrencias>

                <filtro
                    ref="filtroModalDetalhado"
                    @filtrar="obterRelatorio($event)"
                ></filtro>

                <filtro-relatorio-resumido
                    ref="filtroModalResumido"
                    @filtrar="obterRelatorio($event)"
                ></filtro-relatorio-resumido>

            </b-card-body>
            <b-card-footer>
                <app-btn-voltar></app-btn-voltar>
            </b-card-footer>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import Despesa from '@/app/despesasgerais/componentes/despesas/Despesa.vue';
import Grafico from '../componentes/Grafico'
import Ocorrencias from '../componentes/OcorrenciasGerais'
import filtro from './relatorios/RelatorioDetalhadoDespesaGeralFiltros'
import filtroRelatorioResumido from './relatorios/RelatorioResumidoDespesaGeralFiltros'
import AvaliacoesServicos from './../AvaliacoesServicos'

export default {

    components: {
        Despesa,
        Grafico,
        Ocorrencias,
        filtro,
        filtroRelatorioResumido
    },

    data() {
        return {
            campos: [
                {
                    key: 'pergunta',
                    label: 'Pergunta',
                    sortable: true
                },
                {
                    key: 'respostas',
                    label: 'Respostas'
                },
                {
                    key: 'grafico',
                    label: ''
                }
            ],
            camposRespostas: [
                {
                    key: 'resposta',
                    label: 'Resposta',
                    sortable: true
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade'
                },
                {
                    key: 'percentual',
                    label: 'Percentual'
                }
            ],
            itensPorPagina: 0,
            status: null,
            ocorrencia: null,
            avaliacoes: null,
            problemas: null
        }
    },

    methods: {
        obterTitulos(respostas) {
            return respostas.map((p) => {
                return p.resposta
            })
        },

        obterValores(respostas) {
            return respostas.map((p) => {
                return p.quantidade
            })
        },

        obterDespesas() {
            this.$store.dispatch('addRequest')
            AvaliacoesServicos.ObterAvaliacoesDespesas().then(response => {
                if (response) {
                    if (response.success) {
                        this.avaliacoes = response.data.avaliacaoGrafico
                        this.problemas = response.data.problemas
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        abrirModalRelatorioDetalhado() {
            this.$refs.filtroModalDetalhado.abrir()
        },

        abrirModalRelatorioResumido() {
            this.$refs.filtroModalResumido.abrir()
        }
    },
    created() {
        this.obterDespesas();
    },

    computed: {
            mostrarDespesa() {
                return this.$route.name === 'DespesasGerais_Demandantes_Despesas_Detalhar'
            }
        },
}
</script>

